// Specializaion
import { subGroup, route, meta } from '@/helpers/routes'
import Index from './index/index'

const routes = [
  route('index', '/index', Index, meta('Política de Privacidade', true))
]

export default subGroup('/policy', routes)



// WEBPACK FOOTER //
// ./src/app/professional/privacy-policy/routes.js